import {createWebHistory, createRouter} from "vue-router";
import * as constants from '../stores/constants'

import Home from '../pages/Home';
import Systemverwaltung from '../pages/Systemverwaltung.vue';
import PasswordReset from '../pages/auth/PasswordReset.vue';
import PasswordChange from '../pages/auth/PasswordChange.vue';
import AccountConfirm from '../pages/auth/Confirm.vue';
import Register from '../pages/Register';
import Login from '../pages/Login';
import DashboardEntry from '../pages/DashboardEntry.vue';
import AccountSettings from '../pages/account/Settings';

import PackagesIndex from '../pages/packages/Index.vue';
import PackagesEdit from '../pages/packages/Edit.vue';
import PackagesLanding from '../pages/packages/Landing.vue';
import PackagesBook from '../pages/packages/Book.vue';
import PackagesManage from '../pages/packages/Manage.vue';
import PackagesPaymentReturn from '../pages/packages/PaymentReturn.vue';

import AdCreate from '../pages/ads/Create.vue';
import AdIndex from '../pages/ads/Index.vue';
import AdEdit from '../pages/ads/Edit.vue';
import AdShow from '../pages/ads/Show.vue';
import AdStats from '../pages/ads/Stats.vue';

import CallbackIndex from '../pages/callbacks/Index';

import AccountSurvey from '../pages/account/Survey';
import AccountSupport from '../pages/account/Support.vue';
import AccountSupportCreate from '../pages/account/SupportCreate.vue';
import AccountSupportShow from '../pages/account/SupportShow.vue';
import AccountSupportWordPress from '../pages/account/SupportWordPress.vue';
import AccountInvoices from '../pages/account/Invoices.vue';

import OrganisationsIndex from '../pages/organisations/Index';

import AccommodationsIndex from '../pages/accommodations/Index';
import AccommodationsEdit from '../pages/accommodations/Edit';
import AccommodationsNew from '../pages/accommodations/New';
import AccommodationsStats from '../pages/accommodations/Stats.vue';

import EventsNew from '@/pages/events/New';
import EventsEdit from '@/pages/events/Edit';
import EventsIndex from '@/pages/events/Index';
import EventsStats from '@/pages/events/Stats.vue';

import OffersNew from '../pages/offers/New';
import OffersEdit from '../pages/offers/Edit';
import OffersIndex from '../pages/offers/Index';
import OffersStats from '../pages/offers/Stats.vue';

import DiscoverNew from '../pages/discover/New';
import DiscoverIndex from '../pages/discover/Index';
import WebsitesIndex from '../pages/websites/Index.vue';
import WebsitesStats from '../pages/websites/Stats.vue';
import DomainsIndex from '../pages/domains/Index.vue';
import InquiriesIndex from '../pages/inquiries/Index.vue';
import InquiriesShow from '../pages/inquiries/Show.vue';


import MediaIndex from "@/pages/media/Index.vue";
import MediaEdit from "@/pages/media/Edit.vue";
import {useUserStore} from "@/stores/user";

const PUBLIC_ROUTES = ['systemverwaltung', 'login', 'register', 'confirm', 'callback', 'forgot_password', 'change_password']

const ROUTER_VIEW_WITH_PATH_CHANGES = "<router-view :key=\"$route.fullPath\"></router-view>";

const loginRouteFor = (route) => {
    const loginRoute = {name: 'login'}
    if (!PUBLIC_ROUTES.includes(route.name)) {
        loginRoute.query = {redirect: route.fullPath}
    }
    return loginRoute
}

export const index = [
    {
        path: '/',
        component: {
            template: "<router-view></router-view>"
        },
        children: [
            {
                name: 'home',
                path: '/',
                component: Home
            },
            {
                name: 'systemverwaltung',
                path: '/systemverwaltung',
                component: Systemverwaltung,
                meta: {publicLanding: true}
            },
            {
                path: '/systemverwaltung/cgi-bin/index.pl',
                redirect: {name: 'systemverwaltung', query: {}}
            },
            {
                name: 'forgot_password',
                path: '/forgot_password',
                component: PasswordReset
            },
            {
                name: 'change_password',
                path: '/change_password',
                component: PasswordChange
            },
            {
                name: 'register',
                path: '/register',
                component: Register
            },
            {
                name: 'confirm',
                path: '/confirm/:token',
                component: AccountConfirm
            },
            {
                name: 'dashboard',
                path: '/dashboard',
                component: DashboardEntry
            },
            {
                path: 'media',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'media.index',
                        path: '',
                        component: MediaIndex
                    },
                    {
                        name: 'media.edit',
                        path: ':asset_id/edit',
                        component: MediaEdit
                    },
                ]
            },
            {
                name: 'login',
                path: '/login',
                component: Login
            },
            {
                name: 'callback',
                path: '/callback/:provider',
                component: CallbackIndex
            },

            {
                path: 'accommodations',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'accommodations.index',
                        path: '',
                        component: AccommodationsIndex,
                        meta: {base_type: constants.BASE_TYPES.accommodations}
                    },
                    {
                        name: 'accommodations.new',
                        path: 'new',
                        component: AccommodationsNew,
                        meta: {base_type: constants.BASE_TYPES.accommodations}
                    },
                    {
                        name: 'accommodations.stats',
                        path: ':id/stats',
                        component: AccommodationsStats,
                        meta: {base_type: constants.BASE_TYPES.accommodations}
                    },
                    {
                        path: ':id/:lang?',
                        component: {
                            template: ROUTER_VIEW_WITH_PATH_CHANGES
                        },
                        children: [
                            {
                                name: constants.ROUTES.ACCOMMODATIONS.EDIT,
                                path: '',
                                component: AccommodationsEdit
                            },
                        ]
                    },
                ]
            },
            {
                path: '/offers',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'offers.index',
                        path: '',
                        component: OffersIndex,
                        meta: {base_type: constants.BASE_TYPES.offers}
                    },
                    {
                        name: 'offers.new',
                        path: 'new',
                        component: OffersNew,
                        meta: {base_type: constants.BASE_TYPES.offers}
                    },
                    {
                        name: 'offers.stats',
                        path: ':id/stats',
                        component: OffersStats,
                        meta: {base_type: constants.BASE_TYPES.offers}
                    },
                    {
                        path: ':id/:lang',
                        component: {
                            template: ROUTER_VIEW_WITH_PATH_CHANGES
                        },
                        children: [
                            {
                                name: constants.ROUTES.OFFERS.EDIT,
                                path: '',
                                component: OffersEdit
                            },

                        ]
                    },
                ]
            },
            {
                path: '/discover',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'discover.index',
                        path: '',
                        component: DiscoverIndex,
                        meta: {base_type: constants.BASE_TYPES.discover}
                    },
                    {
                        name: 'discover.new',
                        path: 'new',
                        component: DiscoverNew,
                        meta: {base_type: constants.BASE_TYPES.discover}
                    },
                    {
                        name: 'discover.stats',
                        path: ':id/stats',
                        component: AccommodationsStats,
                        meta: {base_type: constants.BASE_TYPES.discover}
                    },
                    {
                        path: ':id/:lang?',
                        component: {
                            template: ROUTER_VIEW_WITH_PATH_CHANGES
                        },
                        children: [
                            {
                                name: constants.ROUTES.DISCOVER.EDIT,
                                path: '',
                                component: AccommodationsEdit
                            },
                        ]
                    },
                ]
            },
            {
                path: '/events',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'events.index',
                        path: '',
                        component: EventsIndex,
                        meta: {base_type: constants.BASE_TYPES.events}
                    },
                    {
                        name: 'events.new',
                        path: 'new',
                        component: EventsNew,
                    },
                    {
                        name: 'events.stats',
                        path: ':id/stats',
                        component: EventsStats,
                    },
                    {
                        name: constants.ROUTES.EVENTS.EDIT,
                        path: ':id/edit',
                        component: EventsEdit,
                    },
                    {
                        path: ':id/:lang',
                        component: {
                            template: ROUTER_VIEW_WITH_PATH_CHANGES
                        },
                        children: [
                            {
                                name: 'events.edit',
                                path: '',
                                component: EventsEdit
                            },

                        ]
                    },
                ]
            },
            {
                name: 'inquiries.index',
                path: '/inquiries',
                component: InquiriesIndex
            },
            {
                name: 'inquiries.show',
                path: '/inquiries/:id',
                component: InquiriesShow
            },
            {
                path: '/websites',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'websites.index',
                        path: '',
                        component: WebsitesIndex,
                    },
                    {
                        name: 'websites.stats',
                        path: ':website_id/stats',
                        component: WebsitesStats,
                    },
                ]
            },
            {
                name: 'domains.index',
                path: '/domains',
                component: DomainsIndex,
            },
            {
                path: '/ads',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                children: [
                    {
                        name: 'ads.create',
                        path: 'create',
                        component: AdCreate,
                    },
                    {
                        name: 'ads.index',
                        path: '',
                        component: AdIndex,
                    },
                    {
                        name: 'ads.edit',
                        path: ':ad_id/edit',
                        component: AdEdit,
                    },
                    {
                        name: 'ads.stats',
                        path: ':ad_id/stats',
                        component: AdStats,
                    },
                    {
                        name: 'ads.show',
                        path: ':ad_id',
                        component: AdShow,
                    },
                ]
            },
            {
                name: 'packages.index',
                path: '/packages',
                component: PackagesLanding
            },
            {
                name: 'packages.book',
                path: '/packages/:id/book',
                component: PackagesBook
            },
            {
                name: 'packages.manage',
                path: '/packages/:id/manage',
                component: PackagesManage
            },
            {
                name: 'packages.payment_return',
                path: '/packages/payment-return',
                alias: ['/payments/result'],
                component: PackagesPaymentReturn
            },
            {
                path: '/admin',
                component: {
                    template: ROUTER_VIEW_WITH_PATH_CHANGES
                },
                meta: {
                    staffOnly: true,
                },
                children: [
                    {
                        name: 'admin.packages.index',
                        path: 'packages',
                        component: PackagesIndex
                    },
                    {
                        name: 'admin.packages.edit',
                        path: 'packages/:id/edit',
                        component: PackagesEdit
                    },
                ]
            },

            {
                path: 'account',
                component: {
                    template: "<router-view></router-view>"
                },
                children: [
                    {
                        path: 'survey',
                        name: 'account.survey',
                        component: AccountSurvey
                    },
                    {
                        path: 'settings',
                        name: 'account.settings',
                        component: AccountSettings
                    },
                    {
                        path: 'support',
                        name: 'account.support',
                        component: AccountSupport
                    },
                    {
                        path: 'invoices',
                        name: 'account.invoices',
                        component: AccountInvoices
                    },
                    {
                        path: 'support/new',
                        name: 'account.support.create',
                        component: AccountSupportCreate
                    },
                    {
                        path: 'support/wordpress',
                        name: 'account.support.wordpress',
                        component: AccountSupportWordPress
                    },
                    {
                        path: 'support/:ticket_id',
                        name: 'account.support.show',
                        component: AccountSupportShow
                    },
                ]

            },
            {
                name: 'organisations.index',
                path: '/organisations',
                component: OrganisationsIndex
            },
            {
                path: '/objects',
                redirect: (to) => ({
                    name: 'dashboard',
                    query: to.query,
                    hash: to.hash,
                }),
            },

        ]
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes: index,
    // scrollBehavior(to, from, savedPosition) {
    scrollBehavior() {
        // always scroll to top
        return {top: 0}
    },
});

router.beforeEach((to, from, next) => {
    const userStore = useUserStore()

    userStore.initializeAuth()
        .then(async () => {
            const toIsPublic = PUBLIC_ROUTES.includes(to.name)

            if (!toIsPublic) {
                const isAuthenticated = await userStore.ensureFreshSession('navigation').catch(() => false)
                if (!isAuthenticated) {
                    return next(loginRouteFor(to))
                }
            } else if (userStore.isAuthenticated && to.name === 'login' && !userStore.loggingOut) {
                return next({name: 'dashboard'})
            }

            if (!userStore.isAuthenticated) {
                return next()
            }

            const toIsStaffOnly = to.matched.some((record) => record.meta?.staffOnly)
            if (toIsStaffOnly && !userStore.user?.isStaffMember?.()) {
                return next({name: 'dashboard'})
            }

            if (!toIsPublic && !toIsStaffOnly && typeof to.query.kdnr !== 'undefined') {
                try {
                    await userStore.applyKdnrFromRoute(to.query.kdnr)
                } catch (error) {
                    console.error('failed to apply kdnr from route', error)
                }
            }

            const fromKdnr = from.query.kdnr
            const toHasKdnr = typeof to.query.kdnr !== 'undefined'
            if (
                typeof fromKdnr !== 'undefined'
                && !toHasKdnr
                && !toIsPublic
                && !userStore.stoppingImpersonation
            ) {
                return next({
                    ...to,
                    query: {
                        ...to.query,
                        kdnr: fromKdnr
                    }
                })
            }

            return next()
        })
        .catch(() => next(loginRouteFor(to)))
})

export default router;
